import styled from "styled-components"

import { Button, spacing, Text } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import { useRouter } from "src/router/useRouter"
import { MCard } from "src/ui/MCard/MCard"

export function NoIntegrations() {
  const { t, langKeys } = useTranslate()
  const { navigate } = useRouter()

  return (
    <MCard padding={spacing.M} boxShadow={false} border={true}>
      <Text variant="heading3">
        {t(langKeys.portfolio_analytics_integrations_status)}
      </Text>
      <ContentWrapper>
        <TextWrapper>
          <Text variant="heading2">
            {t(
              langKeys.portfolio_analytics_integrations_status_no_integrations_title
            )}
          </Text>
          <Text variant="bodyS" color="secondary">
            {t(
              langKeys.portfolio_analytics_integrations_status_no_integrations_description
            )}
          </Text>
        </TextWrapper>
        <Button
          variant="primary"
          onClick={() => navigate(Routes.OrgIntegrations.location())}
        >
          {t(langKeys.onboarding_connect_integrations_action)}
        </Button>
      </ContentWrapper>
    </MCard>
  )
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.L};
  align-items: center;
  justify-content: center;
  padding: ${spacing.M};
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.XS};
`
